import env from '../env';
import logger from '../log';

// Dynamic import
const clientPromise = typeof window !== 'undefined' ? import('./browser') : import('./node');

// Initialize immediately
clientPromise.then(client => {
  // connect application insights to logger
  logger.setLoggerTraceFn(client.trackTrace);
  logger.setLoggerExceptionFn(client.trackException);

  // Logging this here so we can pretty-print without a circular dependency
  if (process.env.NODE_ENV === 'production') {
    logger.info('fs4b0O', `Build number: ${env('BUILDNUMBER')}`);
  } else if (process.env.NODE_ENV !== 'test') {
    logger.info('cjmHnY', 'Environment variables', env());
  }
}).catch(() => {
  // Telemetry wiring is best-effort; the proxy below keeps returning a noop client
});

type ClientModule = Awaited<typeof clientPromise>;
type Client = ReturnType<ClientModule['getClient']>;

let client: Client = undefined;

clientPromise.then((module) => {
  client = module.getClient();
}).catch(() => {});

const noop = () => {};

export default new Proxy<NonNullable<Client>>({} as NonNullable<Client>, {
  get: (_, prop) => {
    // If client not loaded yet, return noop to prevent errors
    if (!client) {
      return noop;
    }
    
    const value = client[prop as keyof NonNullable<Client>];
    if (typeof value === 'function') {
      return value.bind(client);
    }
    return value;
  },
});
